var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M29.935 15.62a17.6 17.6 0 0 0-.278-3.124H15.273v5.908h8.22c-.354 1.909-1.43 3.527-3.048 4.61v3.832h4.936c2.888-2.659 4.554-6.574 4.554-11.225z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a783f",
    d: "M15.273 30.546c4.124 0 7.581-1.368 10.108-3.7l-4.936-3.832c-1.368.916-3.117 1.458-5.172 1.458-3.978 0-7.345-2.687-8.546-6.296H1.624v3.957c2.513 4.991 7.678 8.414 13.648 8.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M6.727 18.175a9.2 9.2 0 0 1-.479-2.902 9.2 9.2 0 0 1 .479-2.902V8.414H1.624C.59 10.476 0 12.808 0 15.273s.59 4.797 1.624 6.859z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M15.273 6.074c2.242 0 4.255.771 5.838 2.284l4.38-4.38C22.847 1.513 19.389 0 15.273 0 9.302 0 4.137 3.422 1.624 8.414l5.102 3.957c1.201-3.61 4.568-6.297 8.546-6.297z"
  })));
};
export default SvgGoogle;